// extracted by mini-css-extract-plugin
export default {"buttonDownloadContainer":"Transfers_buttonDownloadContainer__Vjt1v"};